import { always } from 'ramda';

/**
 * A function that returns empty string.
 *
 * @func stubString
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.1.0|v2.1.0}
 * @category Function
 * @sig ... -> String
 * @return {string} The empty string
 * @example
 *
 * RA.stubString(); //=> ''
 * RA.stubString(1, 2, 3); //=> ''
 */
var stubString = /*#__PURE__*/always('');

export default stubString;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/stubString.js
// module id = 760
// module chunks = 0